import React, { useContext, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { AuthContext } from "../../../../../../Contexts/AuthContext/AuthProvider";
import axios from "axios";
import SingleItem from "../SingleItem";
import CustomPaginationMobile from "../../../../../CustomPagination/CustomPaginationMobile";
const NFTReminingHistory = ({ setShow, show }) => {
  function ModalComponent(props) {
    const { authUser } = useContext(AuthContext);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [paginateData, setPaginateData] = useState([]);

    useEffect(() => {
      if (authUser?._id) {
        fetch(
          `https://api.wlffinance.org/api/user/nft/buy/view/${authUser?._id}`,
          {
            method: "GET",
          }
        )
          .then((res) => res.json())
          .then((data) => {
            setData(data.data);
            setPaginateData(data);
            setLoading(false);
          });
      }
    }, [authUser?._id]);

    const handlePage = (event) => {
      try {
        const pageNumber = event?.selected + 1;
        const config = {
          headers: {
            "content-type": "application/json",
          },
        };
        axios
          .get(
            `https://api.wlffinance.org/api/user/nft/buy/view/${authUser?._id}?page=${pageNumber}`,
            config
          )
          .then((response) => {
            setData(response?.data?.data);
            setPaginateData(response?.data);
          })
          .catch((error) => {});
      } catch (error) {
        console.log(error);
      }
    };

    if (loading) {
      return;
    }

    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="New-Coin-Remining-History announcement-modal-show notices-modal-show "
        backdrop="static"
      >
        <div className="announcement-header">
          <h4>Remaining NFT Lists</h4>
          <button onClick={() => setShow(false)}>
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>
        <Modal.Body>
          <section className="mobile-history-page-area">
            <div className="container">
              <div className="mobile-history-item-area">
                <section className="mobile-history-item-list">
                  {data?.length !== 0 ? (
                    data.map((data, index) => {
                      if (data) {
                        return (
                          <SingleItem
                            data={data}
                            index={index}
                            key={data?._id}
                            paginateData={paginateData}
                          ></SingleItem>
                        );
                      }
                    })
                  ) : (
                    <div className="text-center pt-5">
                      <p className="text-write">No records available</p>
                    </div>
                  )}

                  {/* paginateLinks */}
                  <CustomPaginationMobile
                    data={paginateData}
                    handlePage={handlePage}
                  ></CustomPaginationMobile>
                  {/* paginateLinks */}
                </section>
              </div>
            </div>
          </section>
        </Modal.Body>
      </Modal>
    );
  }

  return (
    <>
      <ModalComponent show={show} onHide={() => setShow(false)} />
    </>
  );
};

export default NFTReminingHistory;
